import React from 'react';

const STATUS_CONFIG = {
  draft: {
    label: 'Draft',
    bg: 'bg-zinc-100',
    text: 'text-zinc-600',
    ring: 'ring-zinc-200',
    dot: 'bg-zinc-400',
  },
  pending_approval: {
    label: 'Pending Approval',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    ring: 'ring-amber-200',
    dot: 'bg-amber-500',
    pulse: true,
  },
  approved: {
    label: 'Approved',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    ring: 'ring-blue-200',
    dot: 'bg-blue-500',
  },
  queued: {
    label: 'Queued',
    bg: 'bg-indigo-50',
    text: 'text-indigo-700',
    ring: 'ring-indigo-200',
    dot: 'bg-indigo-500',
  },
  publishing: {
    label: 'Publishing...',
    bg: 'bg-violet-50',
    text: 'text-violet-700',
    ring: 'ring-violet-200',
    dot: 'bg-violet-500',
    pulse: true,
  },
  posted: {
    label: 'Posted',
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    ring: 'ring-emerald-200',
    dot: 'bg-emerald-500',
  },
  failed: {
    label: 'Failed',
    bg: 'bg-red-50',
    text: 'text-red-700',
    ring: 'ring-red-200',
    dot: 'bg-red-500',
    pulse: true,
  },
  canceled: {
    label: 'Canceled',
    bg: 'bg-zinc-50',
    text: 'text-zinc-500',
    ring: 'ring-zinc-200',
    dot: 'bg-zinc-400',
  },
};

export default function PostStatusBadge({ status, size = 'sm', className = '' }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;

  const sizes = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-medium rounded-full ring-1
        ${config.bg} ${config.text} ${config.ring}
        ${sizes[size] || sizes.sm}
        ${className}
      `}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full ${config.dot} ${config.pulse ? 'animate-pulse' : ''}`}
      />
      {config.label}
    </span>
  );
}

export { STATUS_CONFIG };
